import { render, staticRenderFns } from "./QuestionAndAnswer.vue?vue&type=template&id=3cc85273&"
import script from "./QuestionAndAnswer.vue?vue&type=script&lang=js&"
export * from "./QuestionAndAnswer.vue?vue&type=script&lang=js&"
import style0 from "./QuestionAndAnswer.vue?vue&type=style&index=0&id=3cc85273&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports